import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Field, FieldArray } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { TextField } from 'formik-material-ui';
import { Button } from '@shiftfinancial/design-system';

import FormItem from '../../core/FormItem';
import Close from '../../svg/Close';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  cta: {
    margin: '0 4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '0 !important',
  },
  field: {
    paddingTop: '0 !important',
  },
  buttonWrapper: {
    margin: '12px 0',
  },
}));

const TrusteeForm = ({ values }) => {
  const classes = useStyles();
  return (
    <FieldArray
      name="trusteeNames"
      render={(arrayHelpers) => (
        <React.Fragment>
          {values.trusteeNames.map((trustee, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>
              <Grid item xs={12} className={classes.header}>
                <Typography variant="subtitle1">{`Trustee #${index + 1}`}</Typography>
                {index > 0 && (
                  <IconButton
                    aria-label="Delete"
                    size="small"
                    className={classes.cta}
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    <Close title={`Delete Trustee #${index + 1}`} />
                  </IconButton>
                )}
              </Grid>
              <Grid item xs={12} sm={6} className={classes.field}>
                <FormItem label="First name" xs={12}>
                  <Field
                    type="text"
                    name={`trusteeNames[${index}].firstName`}
                    component={TextField}
                    variant="outlined"
                    fullWidth
                    autoFocus
                    data-testid="firstName"
                  />
                </FormItem>
              </Grid>
              <Grid item xs={12} sm={6} className={classes.field}>
                <FormItem label="Last name" xs={12}>
                  <Field
                    type="text"
                    name={`trusteeNames[${index}].lastName`}
                    component={TextField}
                    values={values}
                    variant="outlined"
                    fullWidth
                    data-testid="lastName"
                  />
                </FormItem>
              </Grid>
            </React.Fragment>
          ))}
          <Grid item xs={12} className={classes.buttonWrapper}>
            <Button
              appearance="secondary"
              onClick={() =>
                arrayHelpers.push({
                  firstName: '',
                  lastName: '',
                })
              }
              data-testid="addAnotherTrusteeButton"
            >
              Add another trustee
            </Button>
          </Grid>
        </React.Fragment>
      )}
    />
  );
};

TrusteeForm.propTypes = {
  values: shape({
    trusteeNames: arrayOf(
      shape({
        firstName: string,
        lastName: string,
      }),
    ),
  }),
};

TrusteeForm.defaultProps = {
  values: {},
};

export default TrusteeForm;
